import React from 'react'
import Main from './components/Main'
import Navbar from './components/Navbar'
import Init from './components/Init'
import AboutUs from './components/AboutUs'
import Construction from './components/Construction'
import Developer from './components/Developer'
import RealEstate from './components/RealEstate'
import Footer from './components/Footer'

export default function Page() {
  return (
    <Main>
      <Navbar />
      <Init />
      <AboutUs />
      <Construction />
      <Developer />
      <RealEstate />
      <Footer />
    </Main>
    
  )
}